import { render, staticRenderFns } from "./OrgInvite.vue?vue&type=template&id=5265b88d"
import script from "./OrgInvite.vue?vue&type=script&lang=js"
export * from "./OrgInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5265b88d')) {
      api.createRecord('5265b88d', component.options)
    } else {
      api.reload('5265b88d', component.options)
    }
    module.hot.accept("./OrgInvite.vue?vue&type=template&id=5265b88d", function () {
      api.rerender('5265b88d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrgInvite.vue"
export default component.exports